const languageList = [
  "English",
  "Spanish",
  "Albanian",
  "Amharic",
  "Arabic",
  "Armenian",
  "Assyrian",
  "Bengali",
  "Bulgarian",
  "Burmese",
  "Cantonese",
  "Cebuano (Visayan)",
  "Chaldean",
  "Chamorro (Guamanian)",
  "Chaozhou (Chiuchow)",
  "Chinese-Mandarin",
  "Dutch",
  "Farsi (Persian)",
  "Filipino - Tagalog",
  "French",
  "German",
  "Greek",
  "Gujarati",
  "Hebrew",
  "Hindi",
  "Hmong",
  "Hungarian",
  "llocano",
  "Indonesian",
  "Italian",
  "Japanese",
  "Kannada",
  "Kashmiri",
  "Khmer (Cambodian)",
  "Khmu",
  "Kikuyu (Gikuyu)",
  "Korean",
  "Kurdish (Kurdi, Kurmanji)",
  "Lahu",
  "Lao",
  "Marathi",
  "Marshallese",
  "Mien (Yao)",
  "Mixteco",
  "Other non-English languages",
  "Pashto",
  "Polish",
  "Portuguese",
  "Punjabi",
  "Rumanian",
  "Russian",
  "Samoan",
  "Serbo-Croatian (Bosnian, Croatian, Serbian)",
  "Sign Language",
  "Somali",
  "Swedish",
  "Taiwanese",
  "Tamil",
  "Telugu",
  "Thai",
  "Tigrinya",
  "Toishanese",
  "Tongan",
  "Turkish",
  "Ukrainian",
  "Unknown",
  "Urdu",
  "Uzbek",
  "Vietnamese",
  "Zapoteco",
];

export default languageList;
